import { getApproverSlots } from '../../../../utils/functions/approverAccess';
// เฉพาะคนที่ถูกตั้งเป็นผู้มีสิทธิ์ของหน้านั้นไว้ที่ /management/approvers เท่านั้นที่เข้าหน้านี้ได้ —
// key: 'payment' (อนุมัติจ่ายเงิน) / 'expense_reviewer' (ตรวจสอบรายการเบิก) ดู mode.accessKey ใน
// constants/modes.js — sidebar ซ่อนเมนูไปแล้ว (ดู MainSidebar.js) แต่กันซ้ำที่ระดับหน้าเผื่อพิมพ์ URL ตรงๆ ด้วย
export function isQueueApprover(me, info, accessKey) {
  const myId = me?.userData?._id;
  if (!myId) return false;
  const cfg = (info?.approver_settings || []).find((c) => c.key === accessKey);
  if (!cfg) return false;
  const ids = getApproverSlots(cfg)
    .map((v) => v?._id || v)
    .filter(Boolean)
    .map((v) => v.toString());
  return ids.includes(myId.toString());
}
